import { DisputeStatus, Query } from '@varo/graphql-schema-types';
import { useRouter } from 'expo-router';
import fetchDisputesList from 'services/graphql/queries/FetchDisputesList';
import {
  DISPUTES_LIST_MIN_SIZE,
  DISPUTES_TXN_MIN_SIZE,
} from 'shared/constants/disputes';
import { useDefaultErrorStrings } from 'shared/hooks/errorFormatters/useDefaultError/useDefaultErrorStrings';
import { useFormattedCombinedError } from 'shared/hooks/errorFormatters/useFormattedCombinedError/useFormattedCombinedError';
import { ErrorScreenType } from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import { useQuery } from 'urql';

const useDisputesList = (disputeType: DisputeStatus) => {
  const router = useRouter();
  const [
    { data: disputesList, fetching: loading, error },
    refetchDisputesList,
  ] = useQuery<Query>({
    query: fetchDisputesList,
    requestPolicy: 'cache-and-network',
    variables: {
      first: DISPUTES_LIST_MIN_SIZE,
      filter: {
        disputeStatus: disputeType,
      },
      transactionFirst: DISPUTES_TXN_MIN_SIZE,
    },
  });

  const refresh = () => {
    refetchDisputesList({ requestPolicy: 'network-only' });
  };

  const cancel = () => {
    router.back();
  };
  const disputesListDetails = disputesList ? disputesList.disputes : undefined;

  const { defaultTitle, defaultMessage, retryButtonTitle, cancelButtonTitle } =
    useDefaultErrorStrings();

  const responseError = useFormattedCombinedError(error);

  const buttons = {
    primaryButton: {
      title: retryButtonTitle,
      onPress: refresh,
    },
    secondaryButton: {
      title: cancelButtonTitle,
      onPress: cancel,
    },
  };

  const errorModel = error
    ? {
        screenType: ErrorScreenType.Error,
        messageHeadline: responseError?.title ?? defaultTitle,
        messageBody: responseError?.message ?? defaultMessage,
        ...buttons,
      }
    : null;

  return {
    disputesListDetails,
    errorModel,
    loading,
    refresh,
  };
};

export default useDisputesList;
